// Module Federation bootstrap pattern — async boundary for shared module negotiation.
import('./bootstrap');
